import React, { useEffect, useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import EnhancedTable from './table';
import Config from '../config';
import EventModal from '../pages/messages/event_modal';
import { Button, Tooltip } from '@mui/material';
import Moment from 'react-moment';
import DocLink from './document_link';

interface EventTableProps {
    filter?: any;
    title?: React.ReactNode;
    onLoad?: (...args: any[]) => void;
    signalr?: any;
    onSignalrUpdate?: any;
    includeDocLink?: boolean;
    refresh?: any;
    [key: string]: any;
}

const EventTable = (props: EventTableProps) => {
    const { filter, title, onLoad, signalr, onSignalrUpdate, includeDocLink, refresh: refreshProp, ...other } = props;

    const [refresh, setRefresh] = useState<boolean | undefined>(undefined);
    const [eventId, setEventId] = useState<any>(undefined);
    const [eventViewed, setEventViewed] = useState<any>(undefined);

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setRefresh(prev => !prev);
    }, [refreshProp]);

    let config = {
        url: Config.api + "/odata/Company/VwActivityEvents",
        columns: [
          { id: 'EventDate', type:'date', filterable: true, sortable: true, label: 'Date', template: (value) => (<Moment format='MM/DD/YYYY hh:mm A'>{value}</Moment>), width: '18em' },
          { id: 'EventLevel', label: 'Severity', width: '3em', filterable: true },
          { id: 'DocType', label: 'Document Type', hidden: true},
          { id: 'DocId', filterable: true, label: 'ID#', width: '5em', hidden: !includeDocLink, template: (value, row) => value && row.DocType ? <DocLink docType={row.DocType} id={value}>{value}</DocLink> : '' },
          { id: 'Summary', label: 'Summary', filterable: true, allowStringOperators: true },
          { id: 'Details', label: 'Details', width: '16em', template: (value) => (
              <Tooltip title={value || ''} enterDelay={300} disableInteractive><span>{value}</span></Tooltip>
          )},
          { id: 'Viewed', hidden: true },
          { id: 'EventTypeId', hidden: true },
          // Force a null commit before re-setting the same id — createRoot batches across await,
          // so Promise.resolve() alone collapses null+id and EventModal never sees a change.
          { id: 'Id', width: '10em', stopPropagation: 'true', template: (value, row) => {return (<Button variant='outlined' onClick={() => {flushSync(() => setEventId(null)); setEventId(value); setEventViewed(row.Viewed);}}>View</Button>);}}
      ],
      order: 'desc',
      orderBy: 'Id',
      keyField: 'Id',
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      title: title,
      refresh: refresh,
      filter: filter,
      onLoad: onLoad,
      signalr: signalr,
      onSignalrUpdate: onSignalrUpdate
  };
  return <>
    <EnhancedTable config={config} {...other}/>
    <EventModal eventId={eventId} viewed={eventViewed} onView={() => setRefresh(prev => !prev)}/>
  </>
}

export default EventTable;
